module.exports = __webpack_public_path__ + "img/4d7df86ace665ba98cab4e5a8fbfa400.png";